import _ from "underts";
//on renvoie le rdv qui suit le rdv en cours parmis tous les rdvs fournis
//note: l'utilisation de duration n'est sans doute pas nécessaire si on considère que la BDD est en bon état
const findNextRdv = (rdv, rdvs) => {
    "use strict";
    const sorted = _.sortBy(rdvs, rdvHourInMinutes);
    const rdvsAfter = sorted.filter((rdv2) => rdvHourInMinutes(rdv2) >=
        rdvHourInMinutes(rdv) + (rdv.duration ? rdv.duration : 0));
    if (rdvsAfter.length > 0) {
        return rdvsAfter[0];
    }
};
const findPreviousRdv = (rdv, rdvs) => {
    "use strict";
    const sorted = _.sortBy(rdvs, rdvHourInMinutes);
    const rdvsBefore = sorted.filter((rdv2) => rdvHourInMinutes(rdv) >=
        rdvHourInMinutes(rdv2) + (rdv2.duration ? rdv2.duration : 0));
    if (rdvsBefore.length > 0) {
        return _.last(rdvsBefore);
    }
};
const rdvHourInMinutes = (rdv) => rdv.hour * 60 + rdv.minute;
export { findNextRdv, findPreviousRdv };
//# sourceMappingURL=findNextAndPreviousRdvs.js.map